import "./SpaceActions.scss"

import classNames from "classnames"
import { Space } from "~/types"
import CopyableLink from "../CopyableLink/CopyableLink"
import ShareSpaceButton from "../ShareSpaceButton/ShareSpaceButton"
import googleMeetIcon from "./google-meet.svg"
import { useSelector } from "react-redux"
import { getUser } from "~/store"
import HarvestTrackingButton from "../HarvestTrackingButton/HarvestTrackingButton"

type SpaceActionsProps = {
  align?: "left" | "center" | "right"
  space?: Space
}

function SpaceActions({ align = "center", space }: SpaceActionsProps) {
  const { share_token, google_meet_url, google_meet_participant_count } =
    space || {}
  const user = useSelector(getUser)

  return (
    <div className="SpaceActions">
      <h4>Actions</h4>
      <div className={`SpaceActions__actions SpaceActions__actions--${align}`}>
        <ShareSpaceButton
          shareToken={share_token!}
          className="SpaceActions__action"
        />
        {google_meet_url && (
          <CopyableLink
            href={google_meet_url}
            title="Go to meeting"
            target="_blank"
            rel="noreferrer"
            className="SpaceActions__action"
          >
            <img src={googleMeetIcon} />
            <div
              className={classNames("SpaceActions__counter", {
                "SpaceActions__counter--visible":
                  google_meet_participant_count &&
                  google_meet_participant_count > 0,
              })}
            >
              {google_meet_participant_count}
            </div>
          </CopyableLink>
        )}
        {user?.has_harvest_access && <HarvestTrackingButton />}
      </div>
    </div>
  )
}

export default SpaceActions
